import { render } from "./RetailerMenuMobile.vue?vue&type=template&id=6c562e4c&scoped=true"
import script from "./RetailerMenuMobile.vue?vue&type=script&lang=js"
export * from "./RetailerMenuMobile.vue?vue&type=script&lang=js"

import "./RetailerMenuMobile.vue?vue&type=style&index=0&id=6c562e4c&scoped=true&lang=css"

import exportComponent from "/Users/victorbello/Documents/Tizeti/Hotspot/eutelsat_branch/Expresswifi_os/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c562e4c"]])

export default __exports__